import React from 'react';
import PropTypes from 'prop-types';

class PureCheckbox extends React.Component {
  handleOnClick = () => {
    const {id, onChange, value} = this.props;

    onChange({target: {id, value: !value}});
  };

  render() {
    const {radioButton, value} = this.props;
    let className = 'mhd--checkbox';

    if (radioButton) {
      className = 'mhd--radio-button';
    }

    if (value) {
      className += ` mhd--${radioButton ? 'radio-button' : 'checkbox'}-checked`;
    }

    const props = {className, onClick: this.handleOnClick};

    return (
      <a {...props} data-testid="checkbox">
        <label />
      </a>
    );
  }
}

PureCheckbox.defaultProps = {
  id: null,
  radioButton: false,
};

PureCheckbox.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  radioButton: PropTypes.bool,
  value: PropTypes.bool.isRequired,

  // functions
  onChange: PropTypes.func.isRequired,
};

export default PureCheckbox;



// WEBPACK FOOTER //
// ./src/components/Common/Form/PureCheckbox.js